import {Select} from '@wandb/weave/components/Form/Select';
import React from 'react';

import {FILE_KEY_DELIMITER, Property} from '../../utilTypes';
import {getDisplayName} from './util';

type DropdownProps = {
  property: Property;
  value: string | number | boolean;
  onChange: (newValue: any, actionMeta: any) => void;
};

type PropertyOption = {
  property: string;
  label?: string;
  value?: string | number | boolean;
};

export const Dropdown = ({property, value, onChange}: DropdownProps) => {
  const items: any[] =
    property.type === 'boolean' ? [true, false] : property.enum ?? [];
  const options: PropertyOption[] = items.map(val => ({
    property: (property.file ?? '') + FILE_KEY_DELIMITER + property.key,
    label: val.toString(),
    value: val,
  }));
  const optionValue: PropertyOption = {
    property: (property.file ?? '') + FILE_KEY_DELIMITER + property.key,
    label: value?.toString(),
    value,
  };
  return (
    <div
      className="m-0 flex flex-col text-sm"
      key={property.key}
      data-test={property.key}>
      <div
        className="w-fit items-center rounded px-4 text-sm font-normal leading-6 text-sienna-500"
        style={{fontFamily: 'Source Code Pro, monospace'}}>
        {getDisplayName(property)}
      </div>
      <div className="my-10 text-sm font-normal leading-6 text-moon-500">
        {property.description}
      </div>
      <Select<PropertyOption, false>
        id={(property.file ?? '') + FILE_KEY_DELIMITER + property.key}
        options={options}
        value={optionValue}
        onChange={onChange}
      />
    </div>
  );
};
